import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'VENUE',
  inside: {
    club: { get: 'venues', set: 'venue' },
  },
});
